import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { formatNumber } from 'core/service/lib/number-format'
import VALUES from 'core/data-model/constants/values'

import { wrapWordingToTextJustify } from 'core/service/benefit-illustration/utils/wording-wrapper'

const TaxGioDeductionBenefit = ({ taxDeduction, productCode }) => {
  const getTaxDeductionValue = () => {
    if (
      Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(productCode) ||
      Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(productCode)
    ) {
      return taxDeduction.taxDeductionTotalForYear
    }
    return taxDeduction.taxDeductionLifeForYear
  }
  return (
    <div id="tax-benefit" className="legal group retirement-tax-benefit">
      <h3>{MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE}</h3>
      <div className="disclaimer">
        <div>{MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} <strong>${wrapWordingToTextJustify(
              MESSAGES.GIO_TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG
            )}</strong>`,
          }}
        />
        <ul className="taxdeduction">
          <li>
            <div>{MESSAGES.TAX_CONSENT_DEDUCTION_BENEFIT_SUB_LIST[0].description}</div>
            <div>
              {Mustache.render(MESSAGES.TAX_CONSENT_DEDUCTION_BENEFIT_SUB_LIST[0].benefit, {
                value: getTaxDeductionValue() === 0 ? '-' : formatNumber(getTaxDeductionValue(), 2, true),
              })}
            </div>
          </li>
        </ul>
        <p
          dangerouslySetInnerHTML={{
            __html: wrapWordingToTextJustify(MESSAGES.TAX_GIO_DEDUCTION_BENEFIT_SUB_ADDITIONAL),
          }}
        ></p>
        <br />
        <p>{MESSAGES.NOTE}:</p>
        <ul>
          <li>
            <strong>{MESSAGES.TAX_GIO_DEDUCTION_BENEFIT_SUB_NOTES[0][0]}</strong>{' '}
            {MESSAGES.TAX_GIO_DEDUCTION_BENEFIT_SUB_NOTES[0][1].replace(/\n/g, '')}
          </li>
        </ul>
      </div>
    </div>
  )
}

export default TaxGioDeductionBenefit
